@switch (context ? context.type : '') {
    @default {
        <fui-edit-switch-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                               (focussed$)="onFocussed($event)"></fui-edit-switch-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-switch-input (focussed$)="onFocussed($event)" [(ngModel)]="value"></fui-filter-switch-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-switch-input (focussed$)="onFocussed($event)" [(ngModel)]="value"></fui-inline-switch-input>
    }
    @case (contextType.PILL) {
        <fui-checkbox-pill (focussed$)="onFocussed($event)" [(ngModel)]="value"></fui-checkbox-pill>
    }
    @case (contextType.POP) {
        <fui-pop-switch-input (focussed$)="onFocussed($event)" [(ngModel)]="value"></fui-pop-switch-input>
    }
}
